const KEY = 'ME';

export { KEY };
